<template>
  <div>
    <div class="reporting-call-logs-header">
      <h2 v-t="'HEADER_SEARCH_BIDS'" class="reporting-call-logs-header__title" />
    </div>
    <div class="r-form display-flex flex--wrap p-b-15">
      <SearchableDropdown
        v-model="timeZoneId"
        rules="required"
        :config="timeZoneOptions"
        class="rtb-export-timezone m-r-15 m-b-15"
        :clearable="false"
      />
      <div class="r-form__input m-r-15 m-b-10 p-l-0">
        <ValidationProvider
          v-slot="{ classes, errors }"
          rules="required"
          slim
        >
          <input
            v-model="bidId"
            class="form-control"
            size="38"
            :class="classes"
            type="text"
            :placeholder="$t('INPUT_SEARCH_BIDS_PLACEHOLDER')"
          />
        </ValidationProvider>
      </div>
      <PrimaryButton
        :show-loader-on-form="isSearching"
        type="button"
        class="p-l-15 m-b-15"
        :class="isSearching ? 'p-r-35' : 'p-r-15'"
        @click="onSearchRtbLog"
      >
        <i class="fa fa-search p-r-0" aria-hidden="true" />
      </PrimaryButton>
    </div>
    <div class="rtb-dashboard__rtb-log">
      <template v-if="bidRecord">
        <div class="grid_table_holder">
          <table class="table_beauty">
            <thead>
              <tr>
                <th width="25"></th>
                <th v-t="'CELL_BID_STATUS'" />
                <th v-t="'CELL_DT'" />
                <th v-t="'CELL_WINNING_BID'" />
                <th v-t="'CELL_CAMPAIGN'" />
                <th v-t="'CELL_PUBLISHER'" />
                <th v-t="'CELL_BID'" />
              </tr>
            </thead>
            <tbody>
              <RtbRecordRow
                :bidRecord="bidRecord"
                :timeZoneId="translatedTimeZoneId"
                @toggle-bid-details="toggleBidDetails"
              />
            </tbody>
          </table>
        </div>
        <collapse v-model="showBidDetails">
          <RtbRecordDetails
            :bidRecord="bidRecord"
            :timeZoneId="translatedTimeZoneId"
          />
        </collapse>
      </template>
      <div v-if="!bidRecord && hasSearchedBid && !isSearching" class="rtb-dashboard__rtb-log-not-found">
        <p v-t="'BID_RECORD_NOT_FOUND'" class="m-b-0" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import { mapState, mapActions, mapGetters } from 'vuex';
import { STATUS_PENDING, STATUS_ERROR } from '@/store/helpers';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { dateTimeService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import Loader from '@/core/components/Loader';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import PrimaryButton from '@/core/components/PrimaryButton';
import TruncatedTextCopy from '@/angularBridgeCode/components/TruncatedTextCopy';

import RtbRecordRow from './RtbRecordRow';
import RtbRecordDetails from './RtbRecordDetails';

const timeZoneConfig = {
  reduce: (option) => option.id,
  label: 'display',
};

export default {
  name: 'RtbSearch',
  components: {
    Loader,
    SearchableDropdown,
    PrimaryButton,
    TruncatedTextCopy,
    RtbRecordRow,
    RtbRecordDetails
  },
  props: {
  },
  data() {
    return {
      bidId: '',
      bidRecord: null,
      showBidDetails: false,
      hasSearchedBid: false,
      timeZoneId: {
        type: String,
        default() {
          return moment.tz.guess();
        }
      },
    }
  },
  computed: {
    ...mapState(['timezones']),
    ...mapGetters(['accountTimezoneId']),
    ...mapGetters('rtbLogs', [
      'getRtbLogStatus'
    ]),
    translatedTimeZoneId() {
      return dateTimeService.getTimeZoneMapping(this.timeZoneId);
    },
    timeZoneOptions() {
      return {
        options: this.timezones,
        ...timeZoneConfig,
        placeholder: 'Select Timezone'
      };
    },
    isSearching() {
      return this.getRtbLogStatus.status == STATUS_PENDING;
    },
  },
  created() {
    if (!this.timezones?.length) {
      this.getTimezones();
    }
    this.timeZoneId = this.accountTimezoneId;
  },
  methods: {
    ...mapActions(['getTimezones']),
    ...mapActions('rtbLogs', ['getRtbLog']),
    async onSearchRtbLog() {
      if (!this.bidId) {
        return;
      } else {
        this.bidRecord = null;
        this.showBidDetails = false;
        try {
          const bidResult = await this.getRtbLog(this.bidId.trim());
          if (bidResult.report?.records && bidResult.report?.records?.length) this.bidRecord = bidResult.report.records[0];
        } catch {
          if (this.getRtbLogStatus.status === STATUS_ERROR) {
            utilities.errorHandler(this.getRtbLogStatus.error);
          }
        } finally {
          this.hasSearchedBid = true;
        }
      }
    },
    toggleBidDetails(val) {
      this.showBidDetails = val;
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>